export default __webpack_public_path__ + "static/300-52b1b0852c2b60d41620fa40aff3c1d9.gif";